import React, { useEffect, useEffectEvent } from 'react';
import { useModalStack } from './useModalStack';

export function useModalRegistration(
  modalId: string,
  isOpen: boolean,
  onClose: () => void
) {
  const { registerModal, unregisterModal, isTopModal } = useModalStack();
  const handleClose = useEffectEvent(() => onClose());

  useEffect(() => {
    if (!isOpen) return;
    registerModal(modalId, handleClose);
    return () => unregisterModal(modalId);
  }, [isOpen, modalId, registerModal, unregisterModal]);

  return {
    isTopModal: isOpen ? isTopModal(modalId) : false,
    // Return props that disable the modal's own ESC handling
    modalProps: {
      onKeyDown: (e: React.KeyboardEvent) => {
        // Prevent individual modal ESC handling - let the global handler manage it
        if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
        }
      },
    },
  };
}
